if (!customElements.get('category-cards-slider')) {
  customElements.define(
    'category-cards-slider',
    class CategoryCardsSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.category-cards__track');
        this.prevButton = this.querySelector('.category-cards__nav--prev');
        this.nextButton = this.querySelector('.category-cards__nav--next');
        if (!this.track || !this.prevButton || !this.nextButton) return;

        this.onScroll = () => this.requestUpdate();
        this.onPrev = () => this.scrollByCard(-1);
        this.onNext = () => this.scrollByCard(1);

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.prevButton.addEventListener('click', this.onPrev);
        this.nextButton.addEventListener('click', this.onNext);

        this.resizeObserver = new ResizeObserver(() => this.requestUpdate());
        this.resizeObserver.observe(this.track);

        this.updateControls();
      }

      disconnectedCallback() {
        if (!this.track) return;
        this.track.removeEventListener('scroll', this.onScroll);
        this.prevButton.removeEventListener('click', this.onPrev);
        this.nextButton.removeEventListener('click', this.onNext);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        cancelAnimationFrame(this.frame);
      }

      requestUpdate() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.updateControls());
      }

      cardStep() {
        const slide = this.track.querySelector('.category-cards__slide');
        if (!slide) return this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      scrollByCard(direction) {
        const isRtl = getComputedStyle(this.track).direction === 'rtl';
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollBy({
          left: direction * (isRtl ? -1 : 1) * this.cardStep(),
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      }

      updateControls() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const offset = Math.abs(scrollLeft);
        const hasOverflow = scrollWidth - clientWidth > 1;

        this.toggleAttribute('data-static', !hasOverflow);
        this.prevButton.disabled = offset <= 1;
        this.nextButton.disabled = offset + clientWidth >= scrollWidth - 1;
      }
    }
  );
}
